import { render } from "./SubjectGroup.vue?vue&type=template&id=0e8526c2"
import script from "./SubjectGroup.vue?vue&type=script&lang=js"
export * from "./SubjectGroup.vue?vue&type=script&lang=js"

import "./SubjectGroup.vue?vue&type=style&index=0&id=0e8526c2&lang=css"
script.render = render

export default script